import { getApi } from 'common/api-common'
import { blobbyStrings } from './strings'

const defaultStrings = {
  beMoreAgile: 'Be more agile and resilient',
  beMoreAgileDescription:
    'Mailroom supports flexible working and working remotely, which is becoming the norm in many companies.',
  deRiskYourBusiness: 'De-risk your business.',
  deRiskYourBusinessDescription:
    'In the event of a disruptive event, business can operate as usual. Staff can receive their post and other important documents.',
  divertYourPost: 'Divert your post <br/> directly to us',
  divertYourPostDescription: `<p class="mb-lg-8 mb-4">
Divert your post directly to us, or we can collect it, then convert them into actionable, digital documents.
</p><p class="mb-lg-8 mb-4">
 All scans are done in high resolution then converted to PDF with <strong>full-text search</strong>. <strong>Mailroom</strong> can easily integrate with a shared address book (LDAP and Active Directory); and mail can be sent directly to staff members or even sync to cloud storage platforms.
 </p><p class="mb-lg-8 mb-4">
 The <strong>paper copies will be held</strong> for an agreed duration and then securely shred onsite and recycled using our commercial recycling partner Paper Round.
</p><p>With <strong>Mailroom, companies can reduce their property and personnel overheads</strong>, which allows them to <br class="d-sm-none"/> focus on core business functions <br class="d-sm-none"/> and access process innovation <br class="d-sm-none"/> and digital capabilities.
</p>`,
  doesTheWorkFormYou: 'Does the work for you',
  doesTheWorkFormYouDescription:
    'Digitising your mail will save you time in manually opening and sorting every letter.',
  focusOnWhatsImportant: 'Focus on what’s important',
  focusOnWhatsImportantDescription:
    'Reduce the costs of non-core operations and focus on running your business at peak performance.',
  goPaperless: 'Go paperless',
  goPaperlessDescription:
    'Get paper out of your office with Mailroom. Digitising your post allows your company to become paperless and saves office space by eliminating the need for storage.',
  latestTechnology: 'Latest technology and process innovation',
  latestTechnologyDescription:
    'Transform your paper-based operations with Mailroom and let us digitise your post so that it can be searched and retrieved quickly and easily.',
  mailroomSlogan:
    'Operate a better business <br/> with Mailroom the end-to-end<br/> virtual mailroom solution.',
  mailroomSubtitle:
    'Mailroom is an off-site virtual mailroom that specialises in <br class="d-lg-block d-none"/> managing your company’s entire mailroom <br class="d-sm-none"/> operations <br class="d-lg-block d-none"/> from an external<br class="d-sm-none"/> secure processing facility.',
  mailroomTitle: 'Your virtual mailroom provider',
  managingMailroom:
    'Managing your company’s entire mailroom operations from an external secure processing facility.',
  managingMailroomDescription:
    'Check out why mailroom is the perfect solution <br class="d-xl-block d-none"/> for your business.',
  savesTimeSpaceMoney: 'Saves you time, space and money',
  savesTimeSpaceMoneyDescription:
    'Reduce administrative and storage costs associated with postal mail.',
  searchPost:
    '<span>Search</span> <span>Post like</span> <span>It’s an</span> Email',
  seoMailroomDescription:
    'Operate a better business with Mailroom the end-to-end virtual mailroom solution.',
  seoMailroomTitle: 'MailRoom - Your virtual mailroom provider | Hoxton Mix',
  stopWastingTime: 'Stop wasting time passing post around',
  stopWastingTimeDescription:
    'Digitising a company’s post through Mailroom helps you to find the information you require, just like searching for an email. This results in improved customer service, operational efficiency and financial savings.',
  weDeliver: 'We deliver',
  weDeliverDescription:
    'Mail is delivered directly to your inbox, cloud storage or internal systems.',
  weGetYourMail: 'We get your mail',
  weGetYourMailDescription:
    'Mail is diverted to our secure <br class="d-sm-none"/> processing facility.',
  weScanAndDigitise: 'We scan & digitise',
  weScanAndDigitiseDescription:
    'All scans are done in high resolution then converted to PDF with full text search.',
  whyMailroom:
    'Why <span class="d-lg-inline d-flex align-items-center justify-content-center"><img class="mailroom-red-h2" src="/images/logos/mailroom-logo-red.svg" /><span class="mailroom-question">?</span></span>',
  worksNicelyWithOthers: 'Works nicely with others',
  worksNicelyWithOthersDescription:
    'Mailroom is integrated with the leading cloud storage providers so we can synch your post to Google Drive, Dropbox or internal systems.',
}
export const mailroomStrings = getApi().makeStrings({
  en: defaultStrings,
  es: blobbyStrings(defaultStrings),
})
